import {
	Drawer,
	DrawerBody,
	DrawerFooter,
	DrawerHeader,
	DrawerHeading,
	Id,
	SubmitButton,
	laravelServiceSelectFetchConfig,
} from "@dgs/core";
import { Form, Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { contactService } from "../shared/api/contactService";
import { getFullNameFromContactOption } from "../shared/select/ContactSelectField";
import { IContactOptionResource } from "../shared/types";
import { PagedCheckboxMultiSelect } from "./PagedCheckboxMultiSelect";

const StyledForm = styled(Form)`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const StyledDrawerBody = styled(DrawerBody)`
	flex: 1;
`;

interface Props {
	open: boolean;
	handleClose: () => void;
	contactIds: Id[];
	onSubmit: (contactIds: Id[]) => Promise<any>;
}

export const DistributionListContactsDrawer: FC<Props> = ({ contactIds, onSubmit, open, handleClose }) => {
	const { t } = useTranslation();

	return (
		<Drawer open={open} onClose={handleClose}>
			<Formik initialValues={{ contactIds }} onSubmit={({ contactIds }) => onSubmit(contactIds)}>
				<StyledForm>
					<DrawerHeader onClose={handleClose}>
						<DrawerHeading>{t("Manage contacts")}</DrawerHeading>
					</DrawerHeader>
					<StyledDrawerBody>
						<PagedCheckboxMultiSelect
							name="contactIds"
							label={t("Contacts")}
							empty={t("No contacts available.")}
							fetchConfig={laravelServiceSelectFetchConfig(contactService)}
							getOption={(contact: IContactOptionResource) => ({
								id: contact.id,
								name: getFullNameFromContactOption(contact),
							})}
						/>
					</StyledDrawerBody>
					<DrawerFooter>
						<SubmitButton>{t("Save")}</SubmitButton>
					</DrawerFooter>
				</StyledForm>
			</Formik>
		</Drawer>
	);
};
